export default class {
	static isSteppedSeries(pointName, pointDescription, override) {
		if(override) {
			return true;
		}
		if (pointName) {
			if (pointName.toLowerCase().indexOf("session") !== -1) {
				return true;
			}
			if (pointName.toLowerCase().indexOf("status") !== -1) {
				return true;
			}
			if (pointName.toLowerCase().indexOf("setpoint") !== -1) {
				return true;
            }
            if (pointName.toLowerCase().indexOf("count") !== -1) {
                return true;
			}
			if (pointName.toLowerCase().indexOf("seats") !== -1) {
                return true;
            }
		}
		if (pointDescription) {
			if (pointDescription.toLowerCase().indexOf("session") !== -1) {
				return true;
			}
			if (pointDescription.toLowerCase().indexOf("status") !== -1) {
				return true;
			}
			if (pointDescription.toLowerCase().indexOf("setpoint") !== -1) {
				return true;
            }
            if (pointDescription.toLowerCase().indexOf("count") !== -1) {
                return true;
            }
		}
		return false;
	}
}



// WEBPACK FOOTER //
// ./src/utils/steppedSeries.js